<template>
  <div class="train-container">
    <div :class="'teacher effect-1 '+(index%4!==0? 'teacher-right' :'')"
         v-for="(item,index) in teacherList"
         :key="item.id">
      <div class="member-image">
        <img :src="item.url || imgUrl"
             alt="Member"
             width="124"
             height="124"
             class="fit-cover">
      </div>
      <div class="teacher-info">
        <div class="teacher-name overell">{{item.name}}</div>
        <div class="teacher-intro">{{item.career}}</div>
        <div class="social-touch">
          <div class="teacher-edu">{{item.education}}</div>
          <div>
            <div class="goDetail"
                 @click="goTeacherDetail(item.id)">
              查看更多
              <img src="/static/img/gomore.png"
                   alt=""
                   height="12">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      imgUrl: require('@/assets/img/占位图_en.png')
    }
  },
  props: {
    teacherList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    goTeacherDetail (id) {
      this.$router.push({ name: 'teacherInfo', query: { id: id } })
    }
  }
}
</script>
<style scoped>
.train-container {
  width: 1190px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
}
/* 讲师列表 */
.teacher {
  width: 280px;
  height: 250x;
  margin: 75px 0 15px 0;
  text-align: center;
  position: relative;
  padding-bottom: 80px;
}
.teacher-right {
  margin-left: 23px;
}
.member-image img {
  max-width: 100%;
  vertical-align: middle;
}
.teacher:hover {
  background-color: #fff;
}
/*= effect-1 css =*/
.teacher .member-image {
  width: 140px;
  height: 140px;
  border: 8px solid #fff;
  border-radius: 75px;
  display: inline-block;
  margin-top: -72px;
  overflow: hidden;
  transition: 0.3s;
}
.teacher .social-touch {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 0px;
  overflow: hidden;
  padding: 0 18px;
  width: 100%;
  transition: 0.3s;
}
.teacher .member-image img {
  transition: 0.3s;
  border-radius: 60px 0;
}
/* .teacher:hover .member-image{border-color: #e13157; transition: 0.3s; border-radius: 50%;} */
.teacher:hover .social-touch {
  padding: 10px 0 6px;
  height: 80px;
  transition: 0.3s;
  border-top: 2px solid #eeeeee;
}
/*= effect-1 css end =*/
.teacher-info {
  padding: 7px 18px;
}
.teacher-name {
  margin: 0 auto 12px;
  height: 22px;
  font-size: 16px;
  color: #333333;
  /* text-align: center; */
}
.teacher-intro {
  height: 52px;
  font-size: 14px;
  color: #666666;
  text-align: center;
  line-height: 26px;
  overflow: hidden;
}
.teacher-edu {
  padding: 0 18px;
  height: 36px;
  line-height: 18px;
  overflow: hidden;
  font-size: 14px;
  color: #666666;
  margin-bottom: 8px;
}
.goDetail {
  display: inline-block;
  font-size: 12px;
  color: #1d65a8;
  cursor: pointer;
  user-select: none;
}
</style>
